import styled from 'styled-components';

export const BackfillContainer = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  position: relative;
  margin-left: 0.4rem;
`;
